import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useGetPatientSubscriptionCancelOptions(patientId: string) {
  const api = useOsApi()
  return useQuery({
    queryKey: ['cancellation-options', patientId],
    queryFn: async () =>
      dataOrThrow(
        await api.get('/patients/:patientId/subscription/cancel/options', { params: { patientId } })
      ),
    refetchOnWindowFocus: false,
    retry: false,
  })
}
